import { NextPage } from 'next'
import { Box, Typography, Grid } from '@mui/material'
import { isDesktop } from 'react-device-detect'

export const TermsAndConditions: NextPage = () => {
    const data = [
        {
            'type': 1,
            'content': 'THE FOLLOWING TERMS AND CONDITIONS APPLY TO YOUR ACCESS AND THE USE OF THIS WEBSITE AND THE SERVICES PROVIDED HEREIN BY SHENMA CREDIT SDN BHD. BY ACCESSING ANY PAGE OF THIS WEBSITE AND/OR USING THE SERVICES, YOU AGREE TO BE BOUND BY THESE TERMS AND CONDITIONS, WHICH MAY BE UPDATED BY US FROM TIME WITHOUT NOTICE.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'IF YOU DO NOT AGREE TO ANY OF THESE TERMS AND CONDITIONS, PLEASE IMMEDIATELY DISCONTINUE YOUR ACCESS TO THIS WEBSITE AND/OR USE OF THE SERVICES. YOUR CONTINUED ACCESS OR USE OF THIS WEBSITE AND/OR THE SERVICES PROVIDED HEREIN AFTER AN UPDATE BY SHENMA CREDIT WILL CONSTITUTE YOUR ACCEPTANCE OF AND AGREEMENT TO BE BOUND BY THE UPDATED CONDITIONS.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'General',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The term "SHENMA Credit" as used in these terms and conditions refers to SHENMA Credit Sdn Bhd. All products and services of  SHENMA Credit and its partners herein provided are subject to the terms and conditions of the applicable agreements governing their use. These terms and conditions are meant to regulate your access to this website. These terms and conditions shall be read in conjunction with agreements that govern such facilities, products and services. If there is any conflict between these terms and conditions and the terms and conditions of such agreements, the latter will prevail.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'Disclaimer',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The materials and information in this website, including but not limited to services, products, information, data, text, graphics, audio, video, links or other items, are provided by  SHENMA Credit on an "as is" and "as available" basis. References to material and information contained in this website include such material and information provided by third parties.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'SHENMA Credit does not make any express or implied warranties, representations or endorsements including but not limited to any warranties of title, non-infringement, merchantability, usefulness, operation, completeness, currentness, accuracy, satisfactory quality, reliability, fitness for a particular purpose in respect of this website, the material, information and/or functions therein and expressly disclaims liability for errors and omissions in such materials, information and/or functions. Without derogation of the above and/or the terms and conditions of the applicable agreements governing all the products and services of  SHENMA Credit, reasonable measures will be taken by  SHENMA Credit to ensure the accuracy and validity of all information relating to transactions and products of SHENMA Credit. ',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Further,  SHENMA Credit does not warrant or represent that access to the whole or part(s) of this website, the materials, information and/or functions contained therein will be provided uninterrupted or free from errors or that any identified defect will be corrected, or that there will be no delays, failures, errors or loss of transmitted information, that no viruses or other contaminating or destructive properties will be transmitted or that no damage will occur to your computer system.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The materials, information and functions provided in this website shall not under any circumstances be considered or construed as an offer or solicitation to sell, buy, give, take, issue, or transfer, or as the giving of any in any jurisdiction.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You shall be responsible to evaluate the quality, adequacy, completeness, currentness and usefulness of all services, content, advice, opinions and other information obtained or accessible through this website; further you should seek professional advice at all times and obtain independent verification of the materials and information provided herein prior to making any decision based on any such materials or information.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'Links',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Any links from or to third parties’ websites (including hyperlinks to the websites of any regulatory authorities such as Bank Negara Malaysia)  are meant for convenience and reference only. Such linked websites are owned and operated by third parties and as such are not under the control of  SHENMA Credit. Therefore, SHENMA Credit shall not be responsible and makes no warranties in respect of the contents of those websites, the third parties named therein or their products and services. Furthermore, the links provided in this website shall not be considered an endorsement or verification or approval of such linked websites or the contents therein. Linking to any other site is at your sole risk and  SHENMA Credit will not be responsible or liable for any damages in connection with linking. Your use of any such hyperlinks to third parties\' websites and use of any of the information or materials available on such third parties\' websites will at all times be governed by the terms of use of such third parties and any other relevant policies or conditions that such third parties may impose.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'Trademark and Copyright',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'SHENMA Credit owns the trademarks, logos, trade names and service marks displayed on this website. ',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Materials (including any graphic, text, script, music, sound, photograph, image, art, video and other multimedia work or any combination of the same) of this website are at all times protected by copyright and any other applicable intellectual property or proprietary rights, owned exclusively by SHENMA Credit or the relevant third-party vendor (as applicable). No part of these materials may be modified, reproduced, stored in a retrieval system, transmitted (in any form or by any means), copied, distributed, used for creating derivative works or used in any other way for commercial or public purposes without prior written consent of SHENMA Credit. ',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Any such unauthorised reproduction, retransmission or other copying or modification of the contents of this website may be in breach of statutory or common law rights which could be the subject of legal action.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You agree that this website shall not be used for any purpose which is unlawful, abusive, libelous, obscene, threatening or in contravention with any law or regulatory requirements.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'Confidential Information',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'It is SHENMA Credit’s policy to respect the privacy of any information disclosed by you in connection with your access to this website and use of the services ("Confidential Information"). Accordingly, SHENMA Credit will neither edit nor disclose your Confidential Information unless it is required to do so in accordance with any laws or regulations, to protect rights and property of SHENMA Credit, to enforce any provision in these terms and conditions, to provide you with the services, to respond to any claim that any content or your material violates the rights of another person, or as provided for in any terms and conditions governing such facilities, products and services taken up by you, which provide for the disclosure of your Confidential Information.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'SHENMA Credit may from time to time disclose your Confidential Information (only in aggregate or demographic form) to the third party vendors, advertisers, affiliates or other relevant parties for their records. Further information on how SHENMA Credit value your privacy and strive to safeguard your Confidential Information in compliance with the laws of Malaysia, is provided for in the Privacy Notice.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'Exclusion of Liability',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'To the fullest extent permitted by law and without prejudice to any other clauses under these terms and conditions, SHENMA Credit, including any of the SHENMA Credit’s directors, officers and employees shall not be liable for any damages, losses, costs and expenses arising out of or in connection with this website or your use or inability to use this website in connection with any delay, error, omission, defect, computer virus or system failure.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Without limiting the generality of the above clauses and to the fullest extent permitted by law, SHENMA Credit shall not be responsible or liable for any loss, damage or embarrassment incurred or suffered by you or any third party by reason of or arising from:',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'a. your failure to comply with these terms and conditions;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'b. your access, use or inability to access or use this website and/or any other website;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'c. the services provided not being available;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'd. any inaccuracies, errors, defects of any content of this website; and',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'e. the access of any site linked to this website.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'Indemnity',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'In addition to and without prejudice to any other rights or remedies of SHENMA Credit (at law or otherwise) and to the fullest extent permitted by law, you agree to indemnify SHENMA Credit and hold SHENMA Credit fully harmless at all times from and against all claims, proceedings, actions, charges, losses, damages, costs (including all legal costs on full indemnity basis), liabilities, penalties, expenses and all taxes, duties and levies payable on such costs, charges and expenses which SHENMA Credit may sustain, suffer or incur due to:',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'a. your non-compliance or breach of these terms and conditions or any other terms and conditions applicable to you;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'b. any action taken by any party against you for any reason whatsoever including but not limited to any unlawful, fraudulent, negligent use of this website;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'c. any negligent and/or fraudulent act which result from the act or conduct by you; and',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'd. any intellectual property right or proprietary right infringement claim made by a third party against SHENMA Credit in connection with your use of this website.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'Waiver',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'No failure or delay on the part of SHENMA Credit in exercising nor any omission to exercise',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'any right, power, privilege or remedy provided in these terms and conditions shall constitute a waiver by SHENMA Credit to exercise such rights, powers, privileges or remedies or acquiescence of such default. SHENMA Credit retains the right at any time afterwards to strictly enforce or insist on their rights in relation to that breach or any subsequent breach by you.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'Severability',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'If any of these terms and conditions become invalid, illegal, or unenforceable, the invalid, illegal or unenforceable clause is to be treated as not having been included in these terms and conditions and the remainder of these terms and conditions shall continue to be effective and in force and shall not be affected in any way by the invalid, illegal or unenforceable clause.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'Governing Law',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Notwithstanding the place or places from which you gain or attempt to gain access to this website and/or the services, you agree that these terms and conditions, your performance and conduct under these terms and conditions, your access to this website, your use of the services and/or content and any differences or disputes arising in relation to such access or use will, at all times, be governed by and construed in accordance with the laws of Malaysia. You agree to submit and be bound by the exclusive jurisdiction of the Courts of Malaysia.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The performance of SHENMA Credit’s obligations under these terms and conditions is subject always to all applicable laws and regulations. Nothing contained in these terms and conditions diminishes our rights to act so as to comply with and conform to any governmental requests or legal requirements relating to access to this website and use of the services, or relating to any content provided to you or acquired by SHENMA Credit for your use.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You agree that a printed version of these terms and conditions and of any communication given in electronic form will be admissible in judicial or administrative proceedings relating to these terms and conditions, to the same extent as though these terms and conditions or communication had been issued in printed form.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'Queries',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'If you wish to make any queries or reach out to us in relation to this website, you may contact Consumer Service Unit through email or call SHENMA Credit at the following email address and contact number:-',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Consumer Service Unit',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Contact Number: +604 523 0033',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Email: wecare@shenmacredit.com.my',
            'paddingLeft': '0px',
            'underline': false
        },
    ]

    const titleItem = (index: number, content: string, paddingLeft: string, underline: boolean) => {
        return (
            <Grid key={index} item xs={12}>
                <Typography fontSize={isDesktop ? 22 : 16} fontWeight={600} color={'#333333'} style={{ textDecoration: underline ? 'underline' : 'none' }}>{content}</Typography>
            </Grid>
        )
    }

    const contentItem = (index: number, content: string, paddingLeft: string, underline: boolean) => {
        return (
            <Grid key={index} item xs={12} style={{ textDecoration: underline ? 'underline' : 'none' }}>
                <Typography fontSize={isDesktop ? 18 : 14} color={'#333333'} paddingLeft={paddingLeft}>{content}</Typography>
            </Grid>
        )
    }

    return (
        <Box sx={{
            width: '100%',
            paddingTop: isDesktop ? '60px' : '30px',
            paddingBottom: '60px',
            paddingLeft: isDesktop ? '100px' : '20px',
            paddingRight: isDesktop ? '100px' : '20px',
        }}>
            <Grid container rowSpacing={2}>
                {data.map((item, index) => (
                    data[index]['type'] === 1 ? titleItem(index, data[index]['content'], data[index]['paddingLeft'], data[index]['underline']) : contentItem(index, data[index]['content'], data[index]['paddingLeft'], data[index]['underline'])
                ))}
            </Grid>
        </Box>
    )
}
